module.exports = __webpack_public_path__ + "pw.fb40d0e69f93e80cd3b0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pw.svg
// module chunks = styles